import React from 'react';
import { NavLink } from 'react-router-dom';
import { BookOpen, Terminal, Settings, Puzzle, Lock, Layers, Zap, Play, Package } from 'lucide-react';

const navSections = [
  {
    title: 'Getting Started',
    items: [
      { to: '/docs', label: 'Introduction', icon: BookOpen, exact: true },
      { to: '/docs/installation', label: 'Installation', icon: Package },
      { to: '/docs/quick-start', label: 'Quick Start', icon: Zap },
    ],
  },
  {
    title: 'Core Concepts',
    items: [
      { to: '/docs/skeleton', label: 'Skeleton Component', icon: Layers },
      { to: '/docs/fixture', label: 'Fixture Prop', icon: Puzzle },
      { to: '/docs/cli', label: 'CLI Reference', icon: Terminal },
      { to: '/docs/config', label: 'Config File', icon: Settings },
      { to: '/docs/auth', label: 'Authentication', icon: Lock },
    ],
  },
  {
    title: 'Interactive',
    items: [
      { to: '/playground', label: 'Playground', icon: Play },
    ],
  },
];

export function DocsSidebar() {
  return (
    <aside className="w-64 shrink-0 border-r border-white/[0.06] h-[calc(100vh-64px)] sticky top-16 overflow-y-auto py-6 px-4 hidden lg:block" data-testid="docs-sidebar">
      <nav className="space-y-8">
        {navSections.map((section) => (
          <div key={section.title}>
            <h4 className="text-[10px] font-mono uppercase tracking-[0.2em] text-white/30 mb-3 px-3">
              {section.title}
            </h4>
            <ul className="space-y-0.5">
              {section.items.map((item) => {
                const Icon = item.icon;
                return (
                  <li key={item.to}>
                    <NavLink
                      to={item.to}
                      end={item.exact}
                      className={({ isActive }) =>
                        `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-all ${
                          isActive
                            ? 'bg-white/[0.08] text-white font-medium'
                            : 'text-white/50 hover:text-white/80 hover:bg-white/[0.04]'
                        }`
                      }
                      data-testid={`sidebar-link-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      <Icon className="w-4 h-4 shrink-0" />
                      {item.label}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
}
